import React from "react";
import PropTypes from "prop-types";
import { Button, Header, Modal } from "semantic-ui-react";
import { generarClaveDobleFactor } from "../../store/actions/transactionalActions";
import { RESPONSE_MESSAGE_CODE_SUCCESS } from "../../infrastructure/appConstants";
import { toast } from "react-toastify";
import { connect } from "react-redux";

const actions = {
  generarClaveDobleFactor,
};

const ModalClaveDobleFactor = ({
  openModel,
  msgValidacionClaveDobleFactor,
  generarClaveDobleFactorRequest,
  setGeneracionExitosaClaveDobleFactor,
  setOpenModalGenerarClaveDobleFactor,
  generarClaveDobleFactor,
}) => {
  const handleVolverSolicitarClaveDobleFactor = async () => {
    try {
      //Generando clave doble factor
      const response = await generarClaveDobleFactor(
        generarClaveDobleFactorRequest
      );
      //end
      if (response && response.code === RESPONSE_MESSAGE_CODE_SUCCESS) {
        setGeneracionExitosaClaveDobleFactor(true);
        setOpenModalGenerarClaveDobleFactor(false);
        toast.info(response.message);
      }
    } catch (error) {
      if (error && error.data && error.data.status !== 401) {
        setGeneracionExitosaClaveDobleFactor(false);
        setOpenModalGenerarClaveDobleFactor(false);
        toast.error(error.data.message);
      }
    }
  };

  return (
    <Modal
      onClose={() => setOpenModalGenerarClaveDobleFactor(false)}
      onOpen={() => setOpenModalGenerarClaveDobleFactor(true)}
      open={openModel}
      dimmer="inverted"
      size="small"
    >
      <Header icon size="small" color="blue">
        Solicitar Nueva Clave
      </Header>
      <Modal.Content>
        <p>{msgValidacionClaveDobleFactor}</p>
      </Modal.Content>
      <Modal.Actions>
        <Button
          content="Generar"
          labelPosition="right"
          icon="key"
          color="yellow"
          onClick={handleVolverSolicitarClaveDobleFactor}
        />
      </Modal.Actions>
    </Modal>
  );
};

ModalClaveDobleFactor.propTypes = {
  openModel: PropTypes.bool.isRequired,
  msgValidacionClaveDobleFactor: PropTypes.string,
  generarClaveDobleFactorRequest: PropTypes.object.isRequired,
  setGeneracionExitosaClaveDobleFactor: PropTypes.func.isRequired,
  setOpenModalGenerarClaveDobleFactor: PropTypes.func.isRequired,
  generarClaveDobleFactor: PropTypes.func.isRequired,
};

export default connect(null, actions)(ModalClaveDobleFactor);
